import { useState } from 'react';
import useFetch from '../../../../hooks/useFetch';
import { ServiceEvents } from '../../shared/interfaces';
import { buildEndpointIntranetCompany } from '../../EndPoints';
import { EventGuest, EventGuestFilters } from '../../../models/EventGuest';

const useEventGuestService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetEventGuestsByEvent, setFetchingGetEventGuestsByEvent] = useState(false);
    const [fetchingShowEventGuest, setFetchingShowEventGuest] = useState(false);
    const [fetchingStoreEventGuest, setFetchingStoreEventGuest] = useState(false);
    const [fetchingEditEventGuest, setFetchingEditEventGuest] = useState(false);
    const [fetchingUpdateEventGuest, setFetchingUpdateEventGuest] = useState(false);
    const [fetchingDeleteEventGuest, setFetchingDeleteEventGuest] = useState(false);
    const [fetchingActiveEventGuest, setFetchingActiveEventGuest] = useState(false);

    const getEventGuestsByEvent = (event_id: number, eventGuestFilters: EventGuestFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(eventGuestFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        doGet({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(`events/event-guests/${event_id.toString()}/by-event`)}?${queryString}`,
            setFetching: setFetchingGetEventGuestsByEvent
        });
    };

    const showEventGuest = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(`events/event-guests/${id.toString()}/show`)}`,
            setFetching: setFetchingShowEventGuest
        });
    };

    const storeEventGuest = (eventGuest: EventGuest, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: `${buildEndpointIntranetCompany(`events/event-guests/store`)}`,
            type: 'company',
            body: eventGuest,
            setFetching: setFetchingStoreEventGuest
        });
    };

    const editEventGuest = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(`events/event-guests/${id.toString()}/edit`)}`,
            setFetching: setFetchingEditEventGuest
        });
    };

    const updateEventGuest = (id: number, eventGuest: EventGuest, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(
                `events/event-guests/${id.toString()}/update`
            )}`,
            body: eventGuest,
            setFetching: setFetchingUpdateEventGuest
        });
    };

    const deleteEventGuest = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(
                `events/event-guests/${id.toString()}/delete`
            )}`,
            setFetching: setFetchingDeleteEventGuest
        });
    };

    const activeEventGuest = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(
                `events/event-guests/${id.toString()}/active`
            )}`,
            body: { active: active },
            setFetching: setFetchingActiveEventGuest
        });
    };

    return {
        fetchingGetEventGuestsByEvent,
        fetchingShowEventGuest,
        fetchingStoreEventGuest,
        fetchingEditEventGuest,
        fetchingUpdateEventGuest,
        fetchingDeleteEventGuest,
        fetchingActiveEventGuest,
        getEventGuestsByEvent,
        showEventGuest,
        storeEventGuest,
        editEventGuest,
        updateEventGuest,
        deleteEventGuest,
        activeEventGuest
    };
};

export default useEventGuestService;
